import './App.css';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Map from './components/map';
import MaskedInput from 'react-text-mask';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { Button, Checkbox, TextField, Typography, Select, MenuItem, FormControl, FormControlLabel, OutlinedInput, InputLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ReCAPTCHA from "react-google-recaptcha";

require('dotenv').config();

function PhoneTextMask(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
}

function App() {
  const [marker, setMarker] = useState([]);

  const [problem, setProblem] = useState("(Select an Answer)");
  const [description, setDescription] = useState();
  const [name,setName]=useState();
  const [serviceAddress, setServiceAddress]=useState('');
  const [addressObject, setAddressObject]=useState({house_number:"",road:""});
  const [emailAddress,setEmailAddress]=useState();
  const [phoneNumber, setPhoneNumber]=useState();
  const [values, setValues] = useState({
    textmask: '(1  )    -    ',
  });
  const [extension, setExtension]=useState();
  const recaptchaRef = React.createRef();
  const [recaptchaCode, setRecaptchaCode]=useState();
  const [contactMe,setContactMe]=useState(false);
  const [addressError, setAddressError]=useState(false);
  const [helperText, setHelperText]=useState();
  const [submitting, setSubmitting]=useState(false);
  const handleContactMeChange = () =>{
    setContactMe(contactMe===false?true:false);
  }
  const [formIsValid, setFormIsValid]=useState(true);

  const submitForm = (event) =>{
    setFormIsValid(addressError && description.length>3);
 
  
    if(formIsValid){
    var comments ="";
    if (contactMe) {
      comments = "Problem Selected: "+problem +" \n Problem Description: "+description + "\n As marked on map by customer:\n Approximate Latitude: "+marker.lat+"\n Approximate Longitude: "+marker.lng +"\n\nCustomer requests contact regarding this issue"
    } else {
      comments = "Problem Selected: "+problem +" \n Problem Description: "+description + "\n As marked on map by customer:\n Approximate Latitude: "+marker.lat+"\n Approximate Longitude: "+marker.lng;
    }
    const submission = {
                          CategoryCode:"UCS", 
                          PhoneNumber:phoneNumber, 
                          RequestorName:name,
                          RequestorStreet:serviceAddress,
                          RequestorCity:"Leesburg",
                          RequestorState:"VA",
                          RequestorEmail:emailAddress,
                          ProblemCode: "UTL100",  
                          GeneralLocation:serviceAddress,
                          xCoord:marker.lng,
                          yCoord:marker.lat,
                          DepartmentType:"Utilities",
                          CommentFromCustomers: comments,
                          recaptcha:recaptchaCode,
                          address:JSON.stringify(addressObject)
                        }
    
    if (problem==="Sewer smell"||problem==="Broken or missing sanitary sewer manhole cover") {
      submission.ProblemCode="UTL200";
    }
    console.log("Submitting...");
    setSubmitting(true);
    axios.post(process.env.REACT_APP_SERVER_URL + "submit",submission).then((response)=>{alert(response.data.responseDesc); setSubmitting(false);});
    //axios.post("http://localhost:3000/" + "submit",submission).then((response)=>{alert(response.data.responseDesc); setSubmitting(false);});
    //console.log(submission);
    event.preventDefault();
  }
  }

  const onReCAPTCHAChange = (captchaCode) => {
    // If the reCAPTCHA code is null or undefined indicating that
    // the reCAPTCHA was expired then return early
    if(!captchaCode) {
      return;
    }
    // Else reCAPTCHA was executed successfully so proceed with the 
    // alert
    
    console.log("Captcha value:", captchaCode);
    // Reset the reCAPTCHA so that it can be executed again if user 
    // submits another email.
    setRecaptchaCode(captchaCode);

    console.log(recaptchaRef);
  }

  const useStyles = makeStyles((theme) => ({
    root: {
      height:'100vh',
      width:'540px'
    },
    paper: {
      margin: theme.spacing(8, 4),
      marginTop:0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'left',
      padding:'5px',
    },
      form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    formControl:{
      width: '100%',
      padding: '5px',
    },
    phoneNumber:{
      width:'70%',
    },
    label: {
         backgroundColor: "white"
    },
    extension:{
    },
  }));

  const classes=useStyles();

  const handleMarkerLocation = e => {
    setMarker(e.latlng);
  };

  const parseAddress = (address) => {
    var parsedAddress = {};

    var addSplit= address.split(' ');
    setServiceAddress(address);
    if(isNaN(addSplit[0])){
      parsedAddress.house_number =  '';
      parsedAddress.road = address;
    } else{
      parsedAddress.house_number=addSplit[0];
      addSplit.splice(0,1);
      parsedAddress.road=addSplit.join(' ');
    }
    setAddressObject(parsedAddress);
    
  }

  const handleApproximateAddress = (address) => {

    if (typeof address.city!=='undefined'){
      if (address.city!=='Leesburg'){
        console.log("Not lessburg address");
        setAddressError(true);
        setHelperText("Not a Town of Leesburg location, please contact your local water service provider.");
      } else {
        console.log("Leeburg address");
        setAddressError(false);
        setHelperText("");
    }
    } else {
      console.log("Not Leesburg address");
      setAddressError(true);
      setHelperText("Not a Town of Leesburg location, please contact your local water service provider.");
    }

    setServiceAddress(typeof address.house_number!=='undefined'?address.house_number+' '+address.road:'' +address.road);
    setAddressObject(address);
  }

  useEffect(()=>{
    console.log(marker);
  },[marker, Map])

  return (
    <div className="App">
      <Grid container direction="column" xs spacing={3} className={classes.root}>
        <Paper className={classes.paper} elevation={0}>
          <form className={classes.form} onSubmit={submitForm}>
            <Grid item xs>
              <FormControl className={classes.formControl}>
                <Typography id="lblProblemSelect">
                  What type of service problem are you having?
                </Typography>
                <Select id="problemSelect" value={problem} variant="outlined" onChange={e=> setProblem(e.target.value)}>
                  <MenuItem value="(Select an Answer)">(Select an Answer)</MenuItem>
                  <MenuItem value="Water leak">Water leak</MenuItem>
                  <MenuItem value="Sewer smell">Sewer smell</MenuItem>
                  <MenuItem value="Low water pressure">Low water pressure</MenuItem>
                  <MenuItem value="Broken clean out">Broken clean out cap</MenuItem>
                  <MenuItem value="Loose, broken, or missing meter lid">Loose, broken, or missing meter lid</MenuItem>
                  <MenuItem value="Broken or missing sanitary sewer manhole cover">Broken or missing sanitary manhole cover</MenuItem>
                  <MenuItem value="Water quality issue (taste, odor, appearance)">Water quality issue (taste, odor, appearance)</MenuItem>
                </Select>
              </FormControl>
              <br/><br/>
            </Grid>
            <Grid item xs>
              <Typography>Tap/Click the map to indicate the approximate location of the issue</Typography>
                <Map markerLocation={marker} handleMarkerLocation={handleMarkerLocation} handleApproximateAddress={handleApproximateAddress}></Map>
            </Grid>
            <Grid item xs>
              <FormControl className={classes.formControl}>
                <Typography>You can type in or correct the approximate location in the box below:</Typography>
                <TextField required id="txtServiceAddress" label="Approximate Address"  variant="outlined" defaultValue=" " value={serviceAddress} onChange={e=>parseAddress(e.target.value)} error={addressError} helperText={helperText} ></TextField>
              </FormControl>
            </Grid>
            <Grid item xs>
              <FormControl className={classes.formControl}>
                <Typography>Please describe the water or sewer service issue you observed:</Typography>
                <TextField
                  id="txtProblemDescription"
                  required
                  multiline
                  rows={5}
                  value={description}
                  onChange = {e=> setDescription(e.target.value)}
                  variant="outlined" 
                  ></TextField>
              </FormControl>
            </Grid>
            <Grid item xs>
              <FormControlLabel control={<Checkbox checked={contactMe} onChange={handleContactMeChange}/> } label="Please contact me with updates on this report"/>
            </Grid>
            <Grid item xs>
              
              <FormControl className={classes.formControl}><Typography id="contactInfoSeparator">Your Contact Information:</Typography>
                <TextField id="txtName" label="Name" value={name}  variant="outlined" onChange={e=>setName(e.target.value)}></TextField>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formControl}>            
                <InputLabel style={{left:"15px", backgroundColor:"WHITE", zIndex:"500", paddingLeft:"5px", paddingRight:"5px"}} htmlFor="PhoneNumber">Phone Number</InputLabel> 
                <OutlinedInput
                  value={values.phoneNumber}
                  name="textmask"
                  id="PhoneNumber"
                  inputComponent={PhoneTextMask}
                  className={classes.phoneNumber}
                  onChange={e=>setPhoneNumber(e.target.value)}
                  />
                  </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formControl} >
                <TextField id="txtExtension" label="Ext." variant="outlined" value={extension} onChange={e=>setExtension(e.target.value)}></TextField>
              </FormControl>
            </Grid>
            <Grid item xs>
              <FormControl className={classes.formControl}>
                <TextField id="txtEmailAddress" label="Email Address"  variant="outlined" required={contactMe} value={emailAddress} onChange={ e=>setEmailAddress(e.target.value)}></TextField>
              </FormControl>
            </Grid>
            <Grid item xs>
              <FormControl className={classes.formControl}>
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                  onChange={onReCAPTCHAChange}
                />
              </FormControl>
            </Grid>
            <Grid item xs>
              <FormControl style={{align:"right"}}>
                <Button type="submit" variant="contained" disabled={submitting}>Submit</Button>
                </FormControl>
              </Grid>
          </form> 
        </Paper>
      </Grid>
    </div>
  );
}

export default App;
